import PaymentResult from "../components/result/index";
import { Helmet } from "react-helmet";

const PaymentResultPage = () => {
  return (
    <>
      <Helmet>
        <title>Результат оплаты</title>
      </Helmet>

      <PaymentResult />
    </>
  );
};

export default PaymentResultPage;
